<template>
  <div
    class="loader"
    :style="{
      '--container-height': containerHeight,
      '--loader-height': loaderHeight,
    }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100px"
      height="50px"
      viewBox="0 0 100 50"
    >
      <circle
        cx="25"
        cy="25"
        r="6"
        :fill="color"
      >
        <animate
          attributeName="r"
          calcMode="spline"
          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
          keyTimes="0;0.5;1"
          values="0;6;0"
          dur="1.2s"
          begin="-0.4s"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="50"
        cy="25"
        r="6"
        :fill="color"
      >
        <animate
          attributeName="r"
          calcMode="spline"
          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
          keyTimes="0;0.5;1"
          values="0;6;0"
          dur="1.2s"
          begin="-0.2s"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        cx="75"
        cy="25"
        r="6"
        :fill="color"
      >
        <animate
          attributeName="r"
          calcMode="spline"
          keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
          keyTimes="0;0.5;1"
          values="0;6;0"
          dur="1.2s"
          begin="0s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    containerHeight: {
      type: String,
      default: 'auto',
    },
    loaderHeight: {
      type: String,
      default: 'auto',
    },
    color: {
      type: String,
      default: '#000',
    },
  },
};
</script>

<style scoped lang="scss">
.loader {
  width: 100%;
  height: 100%;
  min-height: var(--container-height);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    display: block;
    width: auto;
    height: var(--loader-height);

    circle:nth-of-type(2) {
      opacity: 0.6;
    }

    circle:nth-of-type(3) {
      opacity: 0.3;
    }
  }
}
</style>
